import React, { useEffect, useState } from 'react';
import { connect, useDispatch } from 'react-redux';
import NutProfile from './NutProfile';
import UserProfileView from "../profileview";
import { CARD3DS_TYPE, FOLLOW_STATUS, NUT_THEME_USERS, TRANSACTION_TYPE } from '../../utils/constants';
import { ProfileContext } from './ProfileContext';
import { useHistory, useLocation } from 'react-router';
import { setAlert } from '../../../redux/actions';
import pusher from '../../utils/pusher.js';
import { CircularProgress, Snackbar } from '@material-ui/core';
import { Alert } from '@mui/material';

const CustomPageContent = ({
    user,
    getUserInformation = () => ({}),
}) => {
    const history = useHistory();
    const dispatch = useDispatch();
    const search = useLocation().search;
    const searchParams = new URLSearchParams(search);

    const [processingIntent, setProcessingIntent] = useState(false);
    const [intentCompleted, setintentCompleted] = useState(false);

    const handlePaymentIntent = (d) => {
        console.log(d);
        let message = '';
        let type = 'info';
        if (d.status) {
            const url = window.location.pathname;
            const urlParts = url.split('/').filter(path => path);
            const segment = urlParts.length > 0 ? urlParts[0].split('?') : '';

            if (segment[0] === d.puLogin && CARD3DS_TYPE.SUBSCRIPTION) {
                history.push(`/${d.puLogin}`);
                return;
            } else {
                message = `Your subscription payment for ${d.puLogin} has been successfully processed`;
                if (d.type == CARD3DS_TYPE.TIP) {
                    message = `Your tip for ${d.puLogin} has been successfully processed`;
                }
                type = 'success';
            }
        } else {
            message = `The purchase has been denied by your bank due to the unsuccessful 3D Secure authentication. You may try again or contact your bank or use another payment card.`;
            if (d.errorCode === 0) {
                message = 'Your card has insufficient funds';
            }
            type = 'error';
        }

        dispatch(setAlert({
            show: true,
            type: type,
            body: message
        }));
    };
    useEffect(() => {
        const isIntent = searchParams.get('payment_intent') && searchParams.get('payment_intent_client_secret');
        const isLoggedIn = localStorage.getItem('loggedin_user');
        if (isIntent && isLoggedIn) {
            // listent for payment status events
            const subscription = pusher.subscribe(`private-intent-${localStorage.getItem('loggedin_user')}`);
            subscription.bind('App\\Events\\PaymentIntentEvent', d => {
                handlePaymentIntent(d);
            });

            console.error('Subscription done');
        }

        return () => {
            pusher.unsubscribe(`private-intent-${localStorage.getItem('loggedin_user')}`);
        };
    }, []);

    const handleCloseIntentInfo = () => { };

    return <>
        <ProfileContext.Provider value={{ processingIntent, intentCompleted }}>
            {
                (NUT_THEME_USERS.includes(user.id) && [FOLLOW_STATUS.UNSUBSCRIBED, false].includes(user.subscription_status))
                    ? <NutProfile user={user} getUserInformation={getUserInformation} />
                    : <UserProfileView user={user} getUserInformation={getUserInformation} />
            }
        </ProfileContext.Provider>
    </>;
};

const mapStateToProps = (state) => {
    return {
    };
};

export default connect(mapStateToProps)(React.memo(CustomPageContent));
